var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirbnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_12011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.2109 0 0 11.2109 0 25C0 38.7891 11.2109 50 25 50C38.7891 50 50 38.7891 50 25C50 11.2109 38.7891 0 25 0Z",
    fill: "#FF5A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 30.5586C23.987 28.6501 23.0971 26.9771 22.8004 25.5457C22.5038 24.3827 22.6224 23.4583 23.1267 22.7724C23.6607 21.9672 24.4617 21.5795 25.5 21.5795C26.5383 21.5795 27.3393 21.9672 27.8733 22.7724C28.3776 23.4583 28.4962 24.3827 28.1996 25.5457C27.8733 27.007 26.9833 28.6769 25.5 30.5586ZM33.7827 34.9722C31.2611 36.0755 28.7662 34.3161 26.6303 31.9304C30.1635 27.4841 30.8161 24.0249 29.3002 21.7853C28.4102 20.503 27.1346 19.8767 25.5 19.8767C22.2071 19.8767 20.3945 22.6799 21.1065 25.9334C21.5218 27.6928 22.6195 29.6938 24.3697 31.9304C23.0569 33.3928 21.3346 35.0516 19.2672 35.2406C16.271 35.6879 13.9244 32.7654 14.9924 29.7505L22.5898 13.9394C23.2382 12.7507 24.0385 11.7326 25.497 11.7326C26.565 11.7326 27.3956 12.3588 27.7516 12.8658L36.0017 29.7505C36.81 31.7907 35.7849 34.103 33.7827 34.9722ZM37.6096 29.1541L30.5461 14.3867C29.2112 11.6431 28.2619 10 25.5 10C22.7708 10 21.6108 11.9085 20.4242 14.3867L13.3904 29.1541C11.8775 33.332 14.9924 37 18.7629 37C19.0003 37 19.2359 36.9702 19.4749 36.9702C21.4328 36.7316 23.4531 35.4791 25.5 33.2396C27.5469 35.4761 29.5672 36.7316 31.5251 36.9702C31.7641 36.9702 31.9997 37 32.2371 37C36.0076 37.003 39.1225 33.332 37.6096 29.1541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_12011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbnb);
export default __webpack_public_path__ + "static/media/Airbnb.8c6c84717941eb088399294e6e6f8848.svg";
export { ForwardRef as ReactComponent };